// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import CollapseTransition from '../../../../../CollapseTransition';
import { ToggleButton } from '../../../../../Collapse';

const otherS = {
  HeaderContainer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    background-color: #EFEFEF;
    padding: 14px 20px;
    flex: 1;
  `,
}

export const S = {
  ...otherS,
  HeaderTitle: styled.div`
    font: 16px Noto Sans TC;
    padding-right: 10px;
  `,
  RightColumn: styled.div`
    display: flex;
    align-items: center;
  `,
  ToggleButton: styled(ToggleButton)``,
  DurationText: styled.div`
    font: 16px Noto Sans TC;
    color: #313131;
    margin-right: 21px;
  `,
  CollapseTransition: styled(CollapseTransition)`
    & + ${otherS.HeaderContainer}{
      border-top: #DEDEDE solid 1px;
    }
  `
}
